import { OperatorFilter, TermFilter } from '@dofleini/query-builder';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { BOOL_ENUM, BoolComponent } from '@/components/TableFilters/components/Types/BoolComponent';

export const UserRepresentativeFilter = ({ applyFilter, filter, ...rest }) => {
  
  const onFinish = useCallback(({ value: values }) => {
    const filters = map(values, value => {
      switch (value) {
        case BOOL_ENUM.TRUE:
          return new TermFilter({ field: filter.field, value: true }).toQuery();
        case BOOL_ENUM.FALSE:
        default:
          return new OperatorFilter({
            type: 'AND',
            filters: [
              new TermFilter({ field: filter.field, value: false }),
              new TermFilter({ field: 'isSoleOwner', value: false })
            ]
          }).toQuery();
      }
    });
    return applyFilter({ type: 'OR', filters });
  }, [applyFilter, filter.field]);
  
  return (
    <BoolComponent {...rest} filter={filter} onFinishRequest={onFinish}/>
  );
};

UserRepresentativeFilter.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  applyFilter: PropTypes.func,
};
